import React from 'react';
import { Dropdown, Button, Space, MenuProps } from 'antd';
import { DownOutlined } from '@ant-design/icons';

import type Sitemap from '../Sitemap';

export const DeviceTypeLabels: Record<Sitemap['adaptiveType'], string> = {
  desktop: 'Desktop',
  mobile: 'Mobile',
  all: 'Both',
} as const;

const options = Object.keys(DeviceTypeLabels) as Sitemap['adaptiveType'][];

function DeviceTypeDropdown({
  value,
  onSelect,
}: {
  value: Sitemap['adaptiveType'];
  onSelect: (value: Sitemap['adaptiveType']) => void;
}) {
  const items: MenuProps['items'] = React.useMemo(
    () =>
      options.map((option) => ({
        key: option,
        label: DeviceTypeLabels[option],
        onClick: () => onSelect(option),
      })),
    [onSelect]
  );

  return (
    <Dropdown menu={{ items, selectedKeys: [value] }}>
      <Button type="link" size="small">
        <Space>
          {DeviceTypeLabels[value]}
          <DownOutlined />
        </Space>
      </Button>
    </Dropdown>
  );
}

export default DeviceTypeDropdown;
